var map = {
  "./uk.json": [
    "319205",
    [
      63449
    ]
  ],
  "./fi.json": [
    "425712",
    [
      12926
    ]
  ],
  "./el.json": [
    "944884",
    [
      40878
    ]
  ],
  "./fr-CA.json": [
    "54196",
    [
      45422
    ]
  ],
  "./ja.json": [
    "975012",
    [
      80642
    ]
  ],
  "./ar.json": [
    "587622",
    [
      99868
    ]
  ],
  "./nn.json": [
    "103521",
    [
      94481
    ]
  ],
  "./cy.json": [
    "42461",
    [
      14225
    ]
  ],
  "./sl.json": [
    "706350",
    [
      35740
    ]
  ],
  "./fr.json": [
    "394165",
    [
      52293
    ]
  ],
  "./ga.json": [
    "757985",
    [
      33714
    ]
  ],
  "./sv-x-k12.json": [
    "995926",
    [
      57096
    ]
  ],
  "./da-x-k12.json": [
    "648876",
    [
      41582
    ]
  ],
  "./nb.json": [
    "379997",
    [
      73917
    ]
  ],
  "./sv.json": [
    "404900",
    [
      95806
    ]
  ],
  "./en-CA.json": [
    "174917",
    [
      94689
    ]
  ],
  "./en.json": [
    "785126",
    []
  ],
  "./pl.json": [
    "294637",
    [
      4717
    ]
  ],
  "./es-ES.json": [
    "247776",
    [
      92318
    ]
  ],
  "./nb-x-k12.json": [
    "924187",
    [
      31643
    ]
  ],
  "./hu.json": [
    "394770",
    [
      47348
    ]
  ],
  "./pt-BR.json": [
    "366848",
    [
      69998
    ]
  ],
  "./th.json": [
    "251029",
    [
      91829
    ]
  ],
  "./ca.json": [
    "595429",
    [
      11225
    ]
  ],
  "./de.json": [
    "340862",
    [
      4624
    ]
  ],
  "./hy.json": [
    "449510",
    [
      51064
    ]
  ],
  "./zh-Hant.json": [
    "837619",
    [
      43575
    ]
  ],
  "./vi.json": [
    "368224",
    [
      85806
    ]
  ],
  "./ht.json": [
    "546173",
    [
      40893
    ]
  ],
  "./tr.json": [
    "656211",
    [
      87975
    ]
  ],
  "./en-GB.json": [
    "256628",
    [
      28126
    ]
  ],
  "./da.json": [
    "833602",
    [
      31732
    ]
  ],
  "./en-AU.json": [
    "995931",
    [
      89459
    ]
  ],
  "./he.json": [
    "508322",
    [
      92900
    ]
  ],
  "./id.json": [
    "610752",
    [
      31802
    ]
  ],
  "./es.json": [
    "480141",
    [
      94113
    ]
  ],
  "./ko.json": [
    "767367",
    [
      60439
    ]
  ],
  "./zh-Hans.json": [
    "511902",
    [
      77760
    ]
  ],
  "./ms.json": [
    "322981",
    [
      35145
    ]
  ],
  "./is.json": [
    "48889",
    [
      55021
    ]
  ],
  "./nl.json": [
    "719527",
    [
      24875
    ]
  ],
  "./fa.json": [
    "618792",
    [
      30918
    ]
  ],
  "./pt.json": [
    "67925",
    [
      7557
    ]
  ],
  "./ru.json": [
    "877040",
    [
      26414
    ]
  ],
  "./it.json": [
    "634704",
    [
      22922
    ]
  ],
  "./mi.json": [
    "699587",
    [
      83227
    ]
  ],
  "./hi.json": [
    "982646",
    [
      51528
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 289683;
module.exports = __rspack_async_context;
